import * as React from 'react';
import Dialog from '@mui/material/Dialog';
import DialogContent from '@mui/material/DialogContent';
import {  Box } from '@mui/material';
import { IoClose } from "react-icons/io5";

export default function RemarksDialog(props) {

    function formatDate(dateString) {
        const date = new Date(dateString);
        const day = date.getDate().toString().padStart(2, '0');
        const month = (date.getMonth() + 1).toString().padStart(2, '0'); // Months are 0-based
        const year = date.getFullYear();
    
        return `${day}/${month}/${year}`;
      }

      function formatTime(dateString) {
        const date = new Date(dateString);
        let hours = date.getHours();
        const minutes = date.getMinutes().toString().padStart(2, '0');
        const seconds = date.getSeconds().toString().padStart(2, '0');
        const ampm = hours >= 12 ? 'PM' : 'AM';
        hours = hours % 12 || 12;
        const formattedHours = hours.toString().padStart(2, '0');
        const formattedTime = `${formattedHours}:${minutes}:${seconds} ${ampm}`;
        return `${formattedTime}`;
      }



    //   console.log("data",props.data);
      
    return (
        <React.Fragment>

            <Dialog
                open={props.open}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
                maxWidth="xs"
                fullWidth
            >

                <Box sx={{ position: 'absolute', top: '8px', right: '8px', cursor: 'pointer', fontSize: '20px' }} onClick={props.handleClose}>
                    <IoClose />
                </Box>

                <DialogContent>
                    <table>
                        <tr>
                            <th>Remarks</th>
                            <td>:</td>
                            <td>{props.data&&props.data.gm_ds_status_updated_by?.gm_remarks} - {formatDate(props.data&&props.data.gm_ds_status_updated_by?.added_at)+ " - " + formatTime(props.data&&props.data.gm_ds_status_updated_by?.added_at)}</td>
                        </tr>
                    </table>
                </DialogContent>
                
            </Dialog>
        </React.Fragment>
    );
}
